import { useRadioStore as e } from "../__chunks/4BXJGRNH.js";
import { RadioContextProvider as i } from "../__chunks/UVUMR3WP.js";
import { jsx as t } from "react/jsx-runtime";
function a(o = {}) {
  const r = e(o);
  return /* @__PURE__ */ t(i, { value: r, children: o.children });
}
export {
  a as RadioProvider
};
//# sourceMappingURL=radio-provider.js.map
